module.exports = __webpack_public_path__ + "img/cleanCr.82345a31.svg";